<template>
    <div>
        <div class="row">
            <div :class="{ 'col-md-4': savedViewType, 'col-md-6': !savedViewType }">
                <l-select
                    v-model="selectedFilterType"
                    :options="availableFilterTypes"
                    :label="label"
                    @change="changeFilter"
                />
            </div>
            <div
                v-if="selectedFilterType !== 'all' && !selectCustomPeriod"
                :class="{ 'col-md-7': savedViewType, 'col-md-6': !savedViewType || hasFilters }"
            >
                <l-input-typeahead
                    ref="filterTypeahead"
                    :show-picture="false"
                    :show-checkbox="true"
                    style="margin-top: 0px;"
                    :label="``"
                    :placeholder="$t(`surveys.details.placeholderFilter`)"
                    :data="currentFilterOptions(selectedFilterType)"
                    :on-select="item => addFilter(item)"
                    :on-input-change="onKeywordChange"
                    :max-matches="200"
                />
            </div>
            <div v-if="selectedFilterType === 'periods' && selectCustomPeriod" class="col-md-3">
                <l-date-picker
                    :label="$t(`analytics.labelLimitTypePeriodStart`)"
                    :value="periodStart ? new Date(periodStart) : ''"
                    :on-date-change="
                        date => {
                            if (date) {
                                addPeriodFilter(date, 'start');
                            }
                        }
                    "
                />
            </div>
            <div v-if="selectedFilterType === 'periods' && selectCustomPeriod" class="col-md-3">
                <l-date-picker
                    :label="$t(`analytics.labelLimitTypePeriodEnd`)"
                    :value="periodEnd ? new Date(periodEnd) : ''"
                    :on-date-change="
                        date => {
                            if (date) {
                                addPeriodFilter(date, 'end');
                            }
                        }
                    "
                />
            </div>
            <div v-if="savedViewType" class="col-md-1 tw-text-lg tw-mt-2">
                <i
                    v-b-popover.hover.top="$t(`multiFilter.listViewsPopover`)"
                    class="fal fa-folders tw-cursor-pointer tw-text-gray-400 hover:tw-text-primary"
                    :class="{
                        'color-primary': savedViews.filter(v => v.type === savedViewType).length,
                    }"
                    @keydown.enter="
                        () => {
                            mode = 'list';
                            showModal = true;
                        }
                    "
                    @click="
                        () => {
                            mode = 'list';
                            showModal = true;
                        }
                    "
                ></i>
            </div>
            <div v-show="savedViewType && hasFilters" class="col-md-1 tw-text-lg tw-mt-2">
                <i
                    v-b-popover.hover.top="$t(`multiFilter.saveViewPopover`)"
                    class="fal fa-folder-plus tw-cursor-pointer tw-text-primary tw-ml-1"
                    @keydown.enter="
                        () => {
                            mode = 'new';
                            savedView = {
                                owners: [],
                            };
                            showModal = true;
                        }
                    "
                    @click="
                        () => {
                            mode = 'new';
                            savedView = {
                                owners: [],
                            };
                            showModal = true;
                        }
                    "
                ></i>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <span v-for="filterType in availableFilterTypes" :key="filterType.key">
                    <span
                        v-show="
                            selectedFilters[filterType.value] &&
                                selectedFilters[filterType.value].length
                        "
                    >
                        <span
                            v-for="(option, index) in selectedFilters[filterType.value]"
                            :key="option._id"
                            class="label label-primary label-filter"
                        >
                            <span v-if="filterType.customAttribute">{{ filterType.text }}: </span>
                            <span
                                class="clickable"
                                tabindex="0"
                                @keyup.enter="removeFilter(filterType.value, index)"
                                @click="removeFilter(filterType.value, index)"
                            >
                                <span v-show="filterType.value !== 'periods'">
                                    {{ option.name }}
                                </span>
                                <span v-show="filterType.value === 'periods'">
                                    {{ option.start | moment("MMM D, YYYY") }} -
                                    {{ option.end | moment("MMM D, YYYY") }}
                                </span>
                                <i class="fal fa-times l-default-margin-s"></i>
                            </span>
                        </span>
                    </span>
                </span>
            </div>
        </div>
        <div v-if="!filterIsNotEmpty && defaultHint" class="tw-text-gray-400 tw-p-1 tw-pl-0">
            {{ defaultHint }}
        </div>

        <l-modal
            v-show="showModal"
            size="m"
            :close-on-backdrop-click="false"
            @close="showModal = false"
        >
            <template #header>{{ modalTitle }}</template>

            <template #body>
                <div v-if="mode === 'list'">
                    <div class="title-row">
                        <l-input-text
                            v-model="searchText"
                            type="text"
                            style="flex-grow: 1"
                            :label="``"
                            :placeholder="$t('multiFilter.placeHolderSearch')"
                            hide-help-block
                            :optional="true"
                        />
                    </div>
                    <div>
                        <l-space :size="3" />

                        <div v-for="savedView in filteredViews" :key="savedView._id" class="title">
                            <div class="row">
                                <div
                                    class="col-md-8 clickable"
                                    @keydown.enter="applySavedView(savedView)"
                                    @click="applySavedView(savedView)"
                                >
                                    {{ savedView.name }}
                                </div>

                                <div v-if="!savedView.removeConfirmation" class="col-md-4">
                                    <button
                                        v-if="savedView.creator._id === currentUser._id"
                                        class="btn btn-primary btn-sm"
                                        @click="showSavedViewDetail(savedView)"
                                    >
                                        <i class="fal fa-pencil"></i>
                                    </button>
                                    <button
                                        v-if="savedView.creator._id === currentUser._id"
                                        style="margin: 0px"
                                        class="btn btn-primary btn-sm"
                                        :class="{
                                            'pull-right': savedView.creator._id !== currentUser._id,
                                        }"
                                        @click="toRemoveView = savedView"
                                    >
                                        <i class="fal fa-trash"></i>
                                    </button>
                                </div>
                                <l-confirmation-modal
                                    v-if="toRemoveView"
                                    :text="$t(`multiFilter.confirmText`)"
                                    @confirm="deleteSavedFilter"
                                    @cancel="toRemoveView = null"
                                />
                            </div>

                            <hr />
                        </div>

                        <l-no-data
                            v-show="!filteredViews.length"
                            :text="$t(`multiFilter.listViewsNoDataText`)"
                        />

                        <l-space :size="1" />
                    </div>
                </div>

                <!-- detail/create -->
                <div v-else>
                    <div class="title-row">
                        <span class="btn-fake color-primary clickable" @click="goBackToList">
                            <i class="fa fa-caret-left r-default-margin-s"></i>
                            {{ $t(`multiFilter.savedView.labelGoBack`) }}
                        </span>
                    </div>

                    <hr />

                    <l-input-text
                        v-model="savedView.name"
                        type="text"
                        style="flex-grow: 1"
                        :label="$t('multiFilter.savedView.name')"
                        :placeholder="$t('multiFilter.placeHolderNew')"
                        hide-help-block
                    />

                    <l-space :size="1" />

                    <l-input-typeahead
                        :label="$t(`multiFilter.savedView.labelOwner`)"
                        :data="users"
                        :on-select="onUserSelect"
                        :on-input-change="onOwnersInputChange"
                        :placeholder="''"
                    >
                    </l-input-typeahead>
                    <span v-for="(user, index) in savedView.owners" :key="user._id">
                        <span
                            class="label label-default clickable r-default-margin-s"
                            tabindex="0"
                            @click="removeSavedViewOwner(index)"
                            @keyup.enter="removeSavedViewOwner(index)"
                        >
                            {{ user.fullname || user.name || `${user.firstname} ${user.lastname}` }}
                            <i class="fa fa-remove"></i>
                        </span>
                    </span>

                    <hr />
                    <div v-if="info" class="alert alert-info">
                        <span>{{ info }}</span>
                    </div>

                    <button
                        class="btn btn-primary btn-block btn-raised"
                        @click="editOrCreateSavedView()"
                    >
                        {{ $t(`multiFilter.savedView.btnCreate`) }}
                    </button>
                </div>

                <div class="footer"></div>
            </template>
        </l-modal>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LConfirmationModal from "@/components/LConfirmationModal";
import LInputTypeahead from "@/components/LInputTypeahead";
import LDatePicker from "@/components/LDatePicker";
import LInputText from "@/components/LInputText";
import LSelect from "@/components/LSelect";
import LModal from "@/components/LModal";
import LNoData from "@/components/LNoData";
import LSpace from "@/components/LSpace";

export default {
    components: {
        LConfirmationModal,
        LInputTypeahead,
        LDatePicker,
        LInputText,
        LSelect,
        LModal,
        LNoData,
        LSpace,
    },
    props: {
        label: {
            type: String,
            default: "",
        },
        filterTypes: {
            type: Array,
            default: () => [],
        },
        filterOptions: {
            type: Object,
            default: () => {},
        },
        preselectedFilters: {
            // preselected filters that can be passed into the component
            type: Object,
            default: () => {},
        },
        autoApplyPreselectedFilters: {
            // in some scenarios we want to automatically apply filters that are fed into the component (and in others we don't)
            type: Boolean,
            default: false,
        },
        includeDeactivatedUsers: {
            // mostly needed for admin filters
            type: Boolean,
            default: false,
        },
        showCustomAttributes: {
            // whether or not to dynamically load custom attributes
            type: Boolean,
            default: false,
        },
        savedViewType: {
            type: String,
            default: "",
        },
        defaultHint: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            customAttributeFilterTypes: [], // customAttribute filters can't be added to the (dynamically changing) filterTypes that is passed on from parent component
            selectedFilterType: "",
            selectedFilters: {},
            periodStart: "",
            periodEnd: "",
            selectCustomPeriod: false,

            newViewName: "", // new saved view's name
            keyResult: {},
            showModal: false,
            mode: "list",
            searchText: "",
            toRemoveView: null, // the view we want to remove
            savedView: {},
            info: "",
        };
    },
    computed: {
        ...mapGetters({
            currentUser: "users/current/user",
            rights: "users/current/rights",
            customAttributes: "users/customAttribute/list",
            usersSearchList: "users/search/list",

            filterOptionsLocalTeams: "teams/local/listSortedByName",
            filterOptionsUsers: "users/search/list",
            filterOptionsLocations: "users/location/list",
            filterOptionsCustomRoles: "teams/customrole/list",
            savedViews: "savedviews/savedviews/list",
        }),
        filterIsNotEmpty() {
            for (const [filterType, filteredValues] of Object.entries(this.selectedFilters)) {
                if (filterType && filteredValues.length) {
                    return true;
                }
            }
            return false;
        },

        availableFilterTypes: function() {
            return [...this.filterTypes, ...this.customAttributeFilterTypes];
        },

        hasFilters() {
            if (!this.savedViewType) {
                // if we don't have type then always return false.
                return false;
            }
            for (const [filterType, filteredValues] of Object.entries(this.selectedFilters)) {
                if (filterType && filteredValues.length) {
                    return true;
                }
            }
            return false;
        },
        filteredViews() {
            const views = this.savedViews.filter(v => v.type === this.savedViewType);
            if (this.searchText) {
                return views.filter(view =>
                    view.name?.toUpperCase().includes(this.searchText.toUpperCase()),
                );
            }
            return views;
        },
        users() {
            return [
                ...this.usersSearchList.map(user => ({
                    _id: user._id,
                    type: "user",
                    firstname: user.firstname,
                    lastname: user.lastname,
                    name: user.fullname,
                    fullname: user.fullname,
                    desc: user.teamRole.title,
                    picture: user.picture,
                })),
            ];
        },
        modalTitle() {
            if (this.mode === "list") {
                return this.$t("multiFilter.titleYourList");
            } else if (this.mode === "detail") {
                return this.$t("multiFilter.titleEdit");
            }
            return this.$t("multiFilter.titleSaveNewOne");
        },
    },
    watch: {
        preselectedFilters: {
            handler() {
                // sometimes filters are loaded dynamically, so we need to watch ...
                this.setPreselectedFilters();
            },
        },
    },
    async created() {
        // default filters

        if (!this.filterTypes.length) {
            this.filterTypes = [
                {
                    value: "localTeams",
                    key: "localTeamFilter",
                    text: this.$t("multiFilter.selectLocalTeams"),
                },
                {
                    value: "users",
                    key: "userFilter",
                    text: this.$t("multiFilter.selectUsers"),
                },
                {
                    value: "locations",
                    key: "locationFilter",
                    text: this.$t("multiFilter.selectLocations"),
                },
            ];
        }

        // set smart defaults for periods

        if (this.filterTypes.some(f => f.value === "periods")) {
            let index = this.filterTypes.findIndex(f => f.value === "periods");

            this.filterTypes[index] = {
                value: "periods",
                key: "periodFilter",
                text: this.$t(`multiFilter.selectTimeframe`),
                options: [
                    {
                        _id: "currentQuarter",
                        name: this.$t("multiFilter.optionCurrentQuarter"),
                        start: this.$moment().startOf("quarter"),
                        end: this.$moment().endOf("quarter"),
                    },
                    {
                        _id: "currentYear",
                        name: this.$t("multiFilter.optionCurrentYear"),
                        start: this.$moment().startOf("year"),
                        end: this.$moment().endOf("year"),
                    },
                    {
                        _id: "lastQuarter",
                        name: this.$t("multiFilter.optionLastQuarter"),
                        start: this.$moment()
                            .subtract(1, "quarter")
                            .startOf("quarter"),
                        end: this.$moment()
                            .subtract(1, "quarter")
                            .endOf("quarter"),
                    },
                    {
                        _id: "lastYear",
                        name: this.$t("multiFilter.optionLastYear"),
                        start: this.$moment()
                            .subtract(1, "year")
                            .startOf("year"),
                        end: this.$moment()
                            .subtract(1, "year")
                            .endOf("year"),
                    },
                    {
                        _id: "custom",
                        name: this.$t("multiFilter.optionCustomTimeframe"),
                    },
                ],
            };
        }

        // preselect first filter

        this.selectedFilterType = this.availableFilterTypes[0].value;

        // Retrieve data for filters

        let filterDataPromises = [];

        if (this.filterTypes.find(t => t.value === "localTeams")) {
            filterDataPromises.push(
                this.$store.dispatch({
                    type: "teams/local/getList",
                    payload: { filter: "all", cache: true },
                }),
            );
        }

        if (this.filterTypes.find(t => t.value === "locations")) {
            filterDataPromises.push(
                this.$store.dispatch({
                    type: "users/location/getList",
                    payload: { cache: true },
                }),
            );
        }

        if (this.filterTypes.find(t => t.value === "customRoles")) {
            filterDataPromises.push(
                this.$store.dispatch({
                    type: "teams/customrole/getList",
                    payload: { cache: true },
                }),
            );
        }

        if (this.showCustomAttributes) {
            filterDataPromises.push(
                this.$store.dispatch({
                    type: "users/customAttribute/getList",
                    payload: { cache: true },
                }),
            );
        }

        await Promise.all(filterDataPromises);

        if (this.showCustomAttributes) {
            this.customAttributes.forEach(a => {
                this.customAttributeFilterTypes.push({
                    value: a._id,
                    key: a._id,
                    text: a.name,
                    options: a.options.map(o => {
                        return { _id: o._id, name: o.name.toString() };
                    }),
                    mutuallyExclusiveOptions: Boolean(a.type === "boolean"),
                    customAttribute: true,
                });
            });
        }

        this.setPreselectedFilters();
        this.$store
            .dispatch({
                type: "savedviews/savedviews/getList",
                payload: { cache: true, status: ["active"] },
            })
            .then();
    },
    methods: {
        editOrCreateSavedView() {
            if (this.savedView?._id) {
                this.$store
                    .dispatch("savedviews/savedviews/edit", {
                        payload: { savedView: this.savedView },
                    })
                    .then(() => {
                        this.info = this.$t(`multiFilter.savedView.msgSaved`);
                        setTimeout(() => {
                            this.info = "";
                        }, 5000);
                    });
            } else {
                const saved = {};
                for (let [filterType, filteredValues] of Object.entries(this.selectedFilters)) {
                    saved[filterType] = filteredValues.map(value => ({
                        _id: value._id,
                        name: value.name || value.fullname,
                    }));
                }
                this.$store
                    .dispatch("savedviews/savedviews/create", {
                        payload: {
                            data: {
                                name: this.savedView.name,
                                owners: this.savedView.owners,
                                filters: saved,
                                type: this.savedViewType,
                            },
                        },
                    })
                    .then(() => {
                        this.newViewName = "";
                        this.showModal = false;
                    });
            }
        },
        showSavedViewDetail(savedView) {
            this.mode = "detail";
            this.savedView = savedView;
        },
        goBackToList() {
            this.mode = "list";
            this.savedView = null;
        },
        removeSavedViewOwner(index) {
            this.savedView.owners.splice(index, 1);
        },
        onUserSelect(user) {
            if (this.savedView.owners.some(owner => owner._id === user._id)) {
                // prevent duplication
                return;
            }
            if (user._id === this.currentUser._id) {
                // should not allow to add self
                return;
            }
            this.savedView.owners.push(user);
        },
        onOwnersInputChange(query) {
            if (query.length >= 2) {
                this.$store.dispatch("users/search/findByName", { query });
            } else {
                this.$store.dispatch("users/search/reset");
            }
        },
        applySavedView(view) {
            this.selectedFilters = {}; // clear all filter first;
            this.setPreselectedFilters(view.filters); // set filters
            this.applyFilters(); // apply
            this.mode = "";
            this.showModal = false;
        },
        deleteSavedFilter() {
            this.$store
                .dispatch("savedviews/savedviews/delete", {
                    payload: { _id: this.toRemoveView._id },
                })
                .then(() => {
                    this.toRemoveView = null;
                });
        },

        changeFilter() {
            this.$refs?.filterTypeahead?.$refs?.typeahead?.$refs?.input?.focus();
            this.selectCustomPeriod = false;
        },
        setPreselectedFilters(filters) {
            // we need to account for some tricky situations here ...
            if (!filters && !this.preselectedFilters) {
                return;
            }

            for (let [filterType, filteredValues] of Object.entries(
                filters || this.preselectedFilters,
            )) {
                let preselectedValues = [];

                if (["user", "users", "manager", "managers"].includes(filterType)) {
                    // users are usually not preloaded as a full list, so we get the populated value from the backend

                    filteredValues.forEach(v => {
                        if (v?._id) {
                            preselectedValues.push({
                                _id: v._id,
                                name: v.name || v.fullname, // some backend inconsistency here
                            });
                        }
                    });
                } else if (filterType === "customAttributes") {
                    // customAttributes are nested, so we need to go one level deeper

                    for (let [customAttributeType, customAttributeValues] of Object.entries(
                        filteredValues,
                    )) {
                        let preselectedCustomAttributes = [];
                        let options = this.currentFilterOptions(customAttributeType);

                        customAttributeValues.forEach(v => {
                            // we're getting raw IDs from the backend, get the corresponding values from preloaded filters
                            let option = options.find(o => o._id === v);
                            if (option) {
                                // only proceed if the option was found
                                preselectedCustomAttributes.push(option);
                            }
                        });

                        this.$set(
                            this.selectedFilters,
                            customAttributeType,
                            preselectedCustomAttributes,
                        );
                    }
                } else if (Array.isArray(filteredValues) && filteredValues.length) {
                    let options = this.currentFilterOptions(filterType);

                    filteredValues.forEach(v => {
                        if (v?._id && v?.name) {
                            // everything we need is here ...
                            preselectedValues.push(v);
                        } else if (v) {
                            // we're getting raw IDs from the backend, get the corresponding values from preloaded filters
                            let option = options.find(o => o._id === v);
                            if (option) {
                                // only proceed if the option was found
                                preselectedValues.push(option);
                            }
                        }
                    });
                }

                // using $set as we don't know the filter types upfront (component is agnostic)

                this.$set(this.selectedFilters, filterType, preselectedValues);

                if (this.autoApplyPreselectedFilters) {
                    this.applyFilters();
                }
            }
        },
        currentFilterOptions(filterType) {
            let currentFilter = this.availableFilterTypes.find(t => t.value === filterType);
            let options = currentFilter?.options || [];

            if (!options.length && ["localTeam", "localTeams"].includes(filterType)) {
                options = this.filterOptionsLocalTeams;
            } else if (
                !options.length &&
                ["user", "users", "manager", "managers"].includes(filterType)
            ) {
                options = this.filterOptionsUsers;
            } else if (!options.length && ["location", "locations"].includes(filterType)) {
                options = this.filterOptionsLocations;
            } else if (!options.length && ["customRole", "customRoles"].includes(filterType)) {
                options = this.filterOptionsCustomRoles;
            }

            return options.map(o => {
                return {
                    ...o,
                    selected: this.selectedFilters?.[filterType]?.some(f => f._id === o._id),
                };
            });
        },
        onKeywordChange(query) {
            if (["user", "users", "manager", "managers"].includes(this.selectedFilterType)) {
                if (query.length >= 2) {
                    this.$store.dispatch("users/search/findByName", {
                        query,
                        includeDeactivatedUsers: this.includeDeactivatedUsers,
                    });
                } else {
                    this.$store.dispatch("users/search/reset");
                }
            }
        },
        addFilter(item) {
            // special case: custom period

            if (this.selectedFilterType === "periods" && item._id === "custom") {
                this.selectCustomPeriod = true;
                return;
            } else if (this.selectedFilterType === "periods") {
                this.addPeriodFilter(item.start, "start");
                this.addPeriodFilter(item.end, "end");
                return;
            } else {
                this.selectCustomPeriod = false;
            }

            // new filter type

            if (!this.selectedFilters[this.selectedFilterType]) {
                this.$set(this.selectedFilters, this.selectedFilterType, []);
            }

            // check if filter already present

            if (this.selectedFilters[this.selectedFilterType].some(f => f._id === item._id)) {
                return;
            }

            // remove other filters if mutually exclusive

            let filterType = this.availableFilterTypes.find(
                f => f.value === this.selectedFilterType,
            );

            if (filterType.mutuallyExclusiveOptions) {
                this.$set(this.selectedFilters, this.selectedFilterType, []);
            }

            // add filter

            this.$set(this.selectedFilters, this.selectedFilterType, [
                ...this.selectedFilters[this.selectedFilterType],
                item,
            ]);

            // unfocus the input so that refocusing shows values again

            this.$refs?.filterTypeahead?.$refs?.typeahead?.$refs?.input?.focus();

            this.applyFilters();
        },
        removeFilter(filterType, index) {
            this.selectedFilters[filterType].splice(index, 1);
            this.applyFilters();
        },
        addPeriodFilter(date, type) {
            let period = {
                start: type === "start" ? date : this.selectedFilters?.periods?.[0]?.start ?? null,
                end: type === "end" ? date : this.selectedFilters?.periods?.[0]?.end ?? null,
            };

            this.$set(this.selectedFilters, "periods", [period]);
            this.applyFilters();
        },
        applyFilters() {
            delete this.selectedFilters.customAttributes;

            let filters = {};

            if (this.showCustomAttributes) {
                filters.customAttributes = {};
            }

            for (const [filterType, filteredValues] of Object.entries(this.selectedFilters)) {
                let currentFilterType = this.availableFilterTypes.find(t => t.value === filterType);

                if (currentFilterType?.customAttribute) {
                    filters.customAttributes[filterType] = filteredValues.map(v => v._id);
                } else {
                    filters[filterType] = filteredValues;
                }
            }
            if (filters.users?.length) {
                filters.users = filters.users.map(user => ({
                    _id: user._id,
                    name: user.name,
                    fullname: user.fullname,
                    picture: user.picture,
                }));
            }

            this.$emit("update", filters);
        },
    },
};
</script>
